/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function BadgeCheckIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="badge-check"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M10.702 2.756C11.567 1.919 12.433 1.919 13.298 2.756L13.298 2.756C14.163 3.593 15.192 3.927 16.384 3.758L16.384 3.758C17.576 3.59 18.276 4.098 18.484 5.284L18.484 5.284C18.692 6.47 19.327 7.345 20.391 7.909L20.391 7.909C21.454 8.473 21.722 9.296 21.193 10.378L21.193 10.378C20.664 11.459 20.664 12.541 21.193 13.622L21.193 13.622C21.722 14.704 21.454 15.527 20.391 16.091L20.391 16.091C19.327 16.655 18.692 17.53 18.484 18.716L18.484 18.716C18.276 19.902 17.576 20.41 16.384 20.242L16.384 20.242C15.192 20.073 14.163 20.407 13.298 21.244L13.298 21.244C12.433 22.081 11.567 22.081 10.702 21.244L10.702 21.244C9.837 20.407 8.808 20.073 7.616 20.242L7.616 20.242C6.424 20.41 5.724 19.902 5.516 18.716L5.516 18.716C5.308 17.53 4.673 16.655 3.609 16.091L3.609 16.091C2.546 15.527 2.278 14.704 2.807 13.622L2.807 13.622C3.336 12.541 3.336 11.459 2.807 10.378L2.807 10.378C2.278 9.296 2.546 8.473 3.609 7.909L3.609 7.909C4.673 7.345 5.308 6.47 5.516 5.284L5.516 5.284C5.724 4.098 6.424 3.59 7.616 3.758L7.616 3.758C8.808 3.927 9.837 3.593 10.702 2.756L10.702 2.756Z" data-tinysvg-shape="star" data-tinysvg-star="12 12 10.5 10 80 0 100" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M8.819 12.99L10.969 15.14" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M10.968 15.141A9.952 9.952 0 0 1 15.97 9.139" data-tinysvg-shape="arc" data-tinysvg-arc="20.5 18 9.952 9.952 196.694 242.921 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
